import { render } from "./ConfigEditor.vue?vue&type=template&id=37ebae46"
import script from "./ConfigEditor.vue?vue&type=script&lang=js"
export * from "./ConfigEditor.vue?vue&type=script&lang=js"

import "./ConfigEditor.vue?vue&type=style&index=0&id=37ebae46&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__